import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import {
  IRestaurantsDraftItem,
  IRestaurantsItem,
} from 'store/slices/restaurants/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadRestaurantsItem,
  saveRestaurantsItem,
  saveRestaurantsItemAsDraft,
} from 'store/slices/restaurants/actions';
import { LangEnum } from 'constants/lang';

import { RestaurantsForm } from './components/RestaurantsForm';
import { mapValuesToForm } from './components/formUtils';

export const AddTranslation = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.restaurants);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadRestaurantsItem(id));
  }, []);

  const onFinish = (values: IRestaurantsItem) => {
    setIsLoading(true);
    dispatch(saveRestaurantsItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/restaurants');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: IRestaurantsDraftItem) => {
    setIsLoading(true);
    dispatch(saveRestaurantsItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/restaurants');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/restaurants');
  };

  // catalog values depends on lang
  const preparedValues = {
    ...item,
    lang: LangEnum.en,
    restaurantTypes: [],
    restaurantTypesData: null,
    foods: [],
    foodsData: null,
    features: [],
    featuresData: null,
  };

  return (
    <MainLayout pageTitle='Создание'>
      {item.id && item.id === Number(id) ? (
        <RestaurantsForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft
          isLoading={isLoading}
          initialValues={mapValuesToForm(preparedValues)}
        />
      ) : null}
    </MainLayout>
  );
};
